import { MegaMenuItemData } from "@/common/contracts/mega-menu.contracts";
import { NEW_IN_ROUTE } from "@/common/static/routes.static";
import {
  PRO_BUYER_NAV_LABEL,
  PRO_BUYER_ROUTE,
} from "@/features/pro-buyer-application/static/pro-buyer-application.static";
import {
  PRO_BUYER_URL_PARAM,
  PRO_BUYER_URL_VALUE,
} from "@/features/pro-buyer-price/static/pro-buyer-price.static";

/** Not a Strapi id; negative so it can never collide with one. */
export const PRO_BUYER_MENU_ITEM_ID = -5688;

const PRO_BUYER_MENU_ITEM: MegaMenuItemData = {
  id: PRO_BUYER_MENU_ITEM_ID,
  label: PRO_BUYER_NAV_LABEL,
  href: PRO_BUYER_ROUTE,
};

/** A Pro Buyer lands on "New" with the strip and filter on (WHO-6571). */
export const PRO_BUYER_OFFER_HREF = `${NEW_IN_ROUTE}?${PRO_BUYER_URL_PARAM}=${PRO_BUYER_URL_VALUE}`;

export type ProBuyerHeaderSurface = "desktop" | "mobile_menu";

export type ProBuyerHeaderState = "guest" | "not_pro_buyer" | "pro_buyer";

const isProBuyerHref = (href?: string | null) =>
  !!href &&
  (href.split(/[?#]/)[0] ?? "").replace(/\/$/, "").endsWith(PRO_BUYER_ROUTE);

const hasProBuyerItem = (items: MegaMenuItemData[]): boolean =>
  items.some(
    item =>
      isProBuyerHref(item.href) ||
      hasProBuyerItem(item.items ?? []) ||
      hasProBuyerItem(item.submenu?.items ?? [])
  );

/**
 * WHO-6571. The mobile menu's own Pro Buyer line, right after "Sale" (last
 * when a site has no "Sale"); `MegaMenuMobileItemList` renders it with
 * `ProBuyerMobileMenuItem`. On desktop it is a button next to Verkoop instead
 * (`ProBuyerHeaderButton`). Added in code so it follows the program flag.
 * Skipped when the menu already links to /pro-buyer, so a Strapi entry never
 * shows twice. Idempotent.
 */
export const withProBuyerMenuItem = (
  items: MegaMenuItemData[],
  enabled: boolean
): MegaMenuItemData[] => {
  if (!enabled || hasProBuyerItem(items)) {
    return items;
  }

  const sale = items.findIndex(item => item.href?.startsWith("/sale"));
  const at = sale >= 0 ? sale + 1 : items.length;

  return [...items.slice(0, at), PRO_BUYER_MENU_ITEM, ...items.slice(at)];
};
